import React from 'react';
import styled from 'styled-components';
import Checkbox from './Checkbox'
 import Logo from 'assets/images/caat.png'
 import { Icon } from "semantic-ui-react";
 import { Link } from "react-router-dom";


const EN1 = "You will not be able to proceed with the assessment until you have checked the following boxes:*"
const FR1 = "Vous ne pourrez pas commencer l'évaluation avant d'avoir coché les cases suivantes :*"

const EN2 = "Anonymity Statement"
const FR2 = "Déclaration d'anonymat"

const EN3 = `The Culture Pulse Check survey does not collect any direct (i.e., name, email address) 
         or indirect (i.e., role) identifiers that link responses to an individual. A minimum of three data points 
         per role is required in the analysis to ensure that individual responses cannot be identified. All responses 
         will be reported anonymously and data will be aggregated to ensure objectivity.`
const FR3 = "La prise du pouls de la culture ne recueille aucun identifiant direct (ex. : nom, courriel) ou indirect (ex. : rôle) qui pourrait relier les réponses à une personne. Un minimum de trois points de données par rôle est nécessaire pour assurer que les réponses individuelles ne peuvent être identifiées. Toutes les réponses seront rapportées anonymement et les données seront regroupées pour assurer l'objectivité."


const EN4 = "Confidentiality Statement"
const FR4 = "Déclaration de protection de la vie privée"

const EN5 = "Your responses will be held in strict confidentiality and only anonymous, aggregate data will be used in reports for your NSO, Culture and Wellness Facilitators, and/or Own The Podium. "
const FR5 = "Vos réponses seront strictement confidentielles et seules des données anonymes et regroupées seront utilisées dans l'élaboration de rapports à l'intention de votre ONS, de vos facilitateurs de culture et de bien-être et/ou À nous le podium."

const EN6 = "Informed Consent"
const FR6 = "Consentement éclairé"

const EN7 = "I hereby give consent for the Culture and Wellness Facilitators to access anonymized and aggregated user data strictly in the further development of the CWF role by promoting collaboration, support and sharing of best practices. An individual's responses cannot be identified. "
const FR7 ="Par la présente, je consens à l'accès aux données d'utilisateur anonymes et regroupées par les facilitateurs de culture et de bien-être, uniquement aux fins du développement du rôle de FCB pour favoriser la collaboration, le soutien et le partage des meilleures pratiques. Les réponses d'une personne particulière ne peuvent être identifiées."

const EN8 ="Secondary Use"
const FR8 ="Usage secondaire"

const EN9 ="I hereby give consent for Own the Podium or designate research partner to use anonymized and aggregated user data strictly in the further development of culture of excellence programming for the benefit of the high performance sport community in Canada. All direct and indirect identifiers, including sport, will be removed. An individual's responses and the NSO's results cannot be identified."
const FR9 ="Par la présente, je consens à ce qu'À nous le podium ou un partenaire de recherche désigné utilise des données d'utilisateur anonymes et regroupées, uniquement aux fins du développement de la programmation de la culture d'excellence à l'intention de la communauté du sport de haut niveau au Canada. Tous les identifiants directs et indirects, incluant le sport, seront supprimés. Les réponses d'une personne et les résultats d'un ONS ne pourront être identifiés. "

const EN10 = "Privacy Agreement"
const FR10 ="Entente de confidentialité"

const EN11 = "We are committed to maintaining the accuracy, confidentiality, and security of your personally identifiable information. "
const FR11 = "Nous nous engageons à maintenir l'exactitude, la confidentialité et la sécurité de vos renseignements permettant d'identifier une personne."

const EN12 = "Privacy Statement"
const FR12 ="Énoncé de confidentialité"

const EN13 ="Do you agree with your personal data being processed as described above and in our privacy statement? You must click accept to participate in this survey."
const FR13 ="Êtes-vous d'accord que vos données personnelles soient traitées tel que décrit ci-dessus et dans notre énoncé de confidentialité ? Vous devez cliquer pour accepter afin de participer à ce sondage."

const EN14 = "If you have any technical questions or concerns regarding your participation in this survey, please contact info@caatcanada.ca."
const FR14 = "Si vous avez des questions techniques ou des préoccupations concernant votre participation à cette enquête, veuillez contacter info@caatcanada.ca."

// English variables
const EN15 = "Potential Risks of Participation";
const EN16 = "The Culture Pulse Check includes questions regarding mental and physical health and wellbeing, psychological safety, and safe sport.";
const EN17 = (<div>We appreciate hearing from you about your experience and encourage your honesty in your response. Due to the anonymity of the survey, we are unable to follow up to any claims. Therefore, it is not an appropriate method to report harm.</div>);
const EN18 = (<div>If the topics in this survey cause you any emotional or psychological stress, you can find sport-specific resources through the <a href="https://www.ccmhs-ccsms.ca">Canadian Centre for Mental Health and Sport</a> or through <a href="https://www.mygameplan.ca/resources/health">Game Plan</a> at <a href="mailto:mentalhealth@mygameplan.ca">mentalhealth@mygameplan.ca</a></div>);
const EN19 = (<div>The Canadian Sport Helpline is a national toll-free sport helpline that offers assistance to victims or witnesses of harassment, abuse or discrimination. The anonymous, confidential and independent bilingual service provides a space for individuals to share and validate their concerns, obtain advice on required next steps, and be referred to appropriate resources for follow up. They can be accessed via phone, text email or live chat from 8AM to 8PM ET 7 days a week. <a href="https://abuse-free-sport.ca">https://abuse-free-sport.ca</a> <a href="mailto:info@abuse-free-sport.ca">info@abuse-free-sport.ca</a> 1-888-837-7678</div>);
const EN20 = (<div>The Sport Dispute Resolution Centre of Canada (SDRCC), provides tools and information to help prevent and resolve disputes at the highest levels of the Canadian sport system. You can learn more information about these services at <a href="http://www.crdsc-sdrcc.ca">http://www.crdsc-sdrcc.ca</a></div>);

// French variables
const FR15 = "Risques potentiels à la participation";
const FR16 = "La prise du pouls de la culture comprend des questions portant sur la santé mentale et physique, le bien‑être, la sécurité psychologique et le sport sécuritaire.";
const FR17 = (<div>Nous souhaitons que vous nous fassiez part de votre expérience et encourageons votre honnêteté dans vos réponses. Cette évaluation est entièrement anonyme. C'est pourquoi nous ne pourrons donner suite à aucune plainte. Par conséquent, ce n'est pas une méthode appropriée pour signaler un abus ou un préjudice.</div>);
const FR18 = (<div>Si les sujets abordés dans ce questionnaire vous causent un stress émotionnel ou psychologique, vous pouvez trouver des ressources spécifiques au sport via le <a href="https://www.ccmhs-ccsms.ca/accueil">Centre canadien de la santé mentale et du sport</a> ou via <a href="https://www.mygameplan.ca/fr/ressources/sante">Plan de Match</a> à <a href="mailto:mentalhealth@mygameplan.ca">mentalhealth@mygameplan.ca</a></div>);
const FR19 = (
  <div>
    La Ligne d'Assistance du Sport Canadien est une ligne d'assistance nationale sans frais pour le sport qui offre de l'aide aux victimes ou aux témoins de harcèlement, d'abus ou de discrimination. Le service bilingue anonyme, confidentiel et indépendant offre un espace où les personnes peuvent partager et valider leurs préoccupations, obtenir des conseils sur les prochaines étapes requises et être référées aux ressources appropriées pour un suivi. Elles sont accessibles par téléphone, courriel, texto ou clavardage en direct de 8 h à 20 h HE, 7 jours sur 7. <a href="https://sport-sans-abus.ca/ligne-dassistance">https://sport-sans-abus.ca/ligne-dassistance</a> <a href="mailto:info@sport-sans-abus.ca">info@sport-sans-abus.ca</a> 1-888-837-7678
  </div>
);

const FR20 = (
  <div>
    Le Centre de règlement des différends sportifs du Canada (CRDSC) fournit des outils et des renseignements pour aider à prévenir et à résoudre les différends aux plus hauts niveaux du système sportif canadien. Vous pouvez en savoir plus sur ces services à <a href="http://www.crdsc-sdrcc.ca">http://www.crdsc-sdrcc.ca</a>
  </div>
);

const EN21 = "Before you Begin";
const EN22 = (
  <div  style={{lineHeight:1.6}}>
    <p>Confused by sport acronyms and terms? Below is a summary of common terms in this assessment that you can refer to: </p>
    <ul>
    <li><strong>Culture of Excellence (COE):</strong> a culture in sport where people and performance are both prioritized.</li>
    <li><strong>DTE:</strong> Daily Training Environment.</li>
    <li><strong>Gold Medal Profile (GMP):</strong> a selection of athlete performance skills and attributes that are based on metrics and benchmarks.</li>
    <li><strong>IST:</strong> Integrated Support Team's are sport science, sports medicine and other team management professionals that support coaches and athletes/teams. Examples include: Mental Performance Consultant, Nutritionist, Therapist, Physician, Physiologist, etc.</li>
    <li><strong>Mental Health:</strong> one's state of psychological and emotional well-being.</li>
    <li><strong>Program leaders:</strong> these individuals may be Coaches, High Performance Directors (HPD), High Performance Managers (HP Manager), and IST providers. </li>
    <li><strong>Physical Health:</strong> a state of physical well-being that takes into consideration how the body feels, moves, and functions.</li>
    <li><strong>Physical Safety:</strong> an environment free from physical danger or maltreatment from physical conduct.</li>
    <li><strong>Psychological Safety:</strong> an environment where mental health is protected and an individual feels as if they won't be punished or humiliated for speaking up about questions, concerns or ideas.  </li>
    </ul>
    <p>
    Other things to consider before you begin: 
    </p>
    <ul>
      
      <li><strong>Code of Conduct:</strong> this is a document that outlines a set of values, behaviours, principles, guidelines or rules which form the base of expectations specific to your sport organization.</li>
      <li><strong>Performance Objective:</strong> objective(s) personal to the athlete, that are defined by or in collaboration with, your coaches, IST providers, and High Performance Directors. You will see this survey refer to your Performance Objectives, in relation to your program and training environment. </li>
    </ul>

  </div>
)

const FR21 = "Avant de commencer";
const FR22 = (
  <div  style={{lineHeight:1.6}}>
    <p>Les acronymes et les termes relatifs au sport vous laissent perplexe ? Vous trouverez ci-dessous un récapitulatif des termes les plus courants dans cette évaluation, auquel vous pourrez vous référer :</p>
    <ul>
    <li><strong>Culture d'excellence :</strong> une culture du sport dans laquelle les personnes et les performances sont toutes deux prioritaires.</li>
    <li><strong>EEQ:</strong> environnement d'entraînement quotidien.</li>
    <li><strong>Le Profil de la médaille d'or :</strong> une sélection de compétences et d'attributs de performance des athlètes qui sont basés sur des mesures et des critères de référence.</li>
    <li><strong>ÉSI:</strong> Les équipes de soutien intégré sont des professionnels des sciences du sport, de la médecine sportive et de la gestion d'équipe qui soutiennent les entraîneurs et les athlètes/équipes. Voici quelques exemples de membres d'une ÉSI: consultant en performance mentale, nutritionniste, physiothérapeute, médecin, physiologiste, etc.</li>
    <li><strong>Santé mentale :</strong> état de bien-être psychologique et émotionnel d'une personne.</li>
    <li><strong>Les personnes responsables du programme:</strong> par exemple, les entraîneurs, directeur(trice)/gestionnaire Haute Performance et membres de l'ÉSI.</li>
    <li><strong>Santé physique :</strong> état de bien-être physique qui prend en compte la façon dont le corps se sent, bouge et fonctionne.</li>
    <li><strong>Sécurité physique :</strong> un environnement exempt de tout danger physique ou de tout mauvais traitement dû à un comportement physique.</li>
    <li><strong>Sécurité psychologique :</strong> un environnement où la santé mentale est protégée et où l'on croit que l'on ne sera pas puni ou humilié pour avoir exprimé ses idées, ses erreurs, ses questions ou ses préoccupations.</li>
    </ul>
    <p>
     Autres éléments à prendre en compte avant de commencer :
    </p>
    <ul>
    <li><strong>Code de conduite :</strong> il s'agit d'un document qui décrit un ensemble de valeurs, de comportements, de principes, de lignes directrices ou de règles propres à votre organisation sportive. Nous vous recommandons de vous familiariser avec le code de conduite de votre organisation avant de commencer l'enquête d'évaluation.</li>
      <li><strong>Objectif de performance :</strong> objectif(s) personnel(s) de l'athlète, défini(s) par ou en collaboration avec vos entraîneurs, directeur(trice)/gestionnaire Haute Performance et membres de l'ÉSI.. Dans cette enquête, vous verrez que vos objectifs de performance sont liés à votre programme et à votre environnement d'entraînement. Si vous avez des questions sur vos objectifs de performance personnels, veuillez contacter les personnes responsables de votre programme.</li>
     
    </ul>

  </div>
)

const EN23 = "Age Consent"
const EN24 = "Are you over the age of 16?"

const FR23 = "Consentement d'âge"
const FR24 = "Avez-vous moins de 16 ans?"

const EN25 = "If you are under the age of 16, you must complete this assessment in the presence of an adult (aged 18 years or older). This adult can be a parent, guardian, coach, NSO staff or Sport science practitioner."
const FR25 = "Si vous avez moins de 16 ans, vous devez effectuer cette évaluation en présence d'un adulte (âgé de 18 ans ou plus). Cet adulte peut être un parent, un tuteur, un entraîneur, un/e directeur(trice)/gestionnaires Haute Performance et membres de l'ÉSI."

const IntroText = ({ language, organizationNameEn, organizationNameFr }) => {
  // Get organization names with fallbacks
  const get_french_name = () => organizationNameFr || "Nom de l'organisation";
  const get_english_name = () => organizationNameEn || "Organization Name";

  if (language == 1) {
    return (
      <div style={{ fontSize: 18 }}>
        <p>
          {get_french_name()} s’engage à renforcer la culture de haute performance de son
          programme de l’Équipe nationale. La santé et la sécurité physiques et psychologiques
          de toutes les personnes impliquées dans le programme sont tout aussi importantes que
          la performance.
        </p>
        <p>
          Dans le cadre de cet engagement, {get_french_name()} a déjà réalisé l’Évaluation et
          l’audit complets de la culture couvrant 11 domaines liés aux personnes et à la
          performance. À la lumière de cet audit, et avec l’appui des facilitateurs de culture
          et de bien-être et d’À nous le podium, l’organisation a élaboré un plan d’action
          axé sur l’amélioration de certain(s) domaine(s).
        </p>

        <p>
          Ce sondage constitue une prise du pouls de la culture sur le(s) domaine(s) que votre
          programme a choisi de prioriser. Son objectif est de comprendre les progrès réalisés
          dans ces domaines et d’identifier ce qui fonctionne bien ainsi que ce qui gagnerait
          à être amélioré.  En raison de votre rôle, vous êtes invité•e à y participer.
        </p>
        <p>
          Toutes les réponses sont anonymes, et votre ouverture contribuera à guider des
          améliorations concrètes.
        </p>
      </div>
    );
  }

  return (
    <div style={{ fontSize: 18 }}>
      <p>
        {get_english_name()} is committed to strengthening the high-performance culture of its
        National Team Program. The physical and psychological health and safety of everyone
        involved in the program are of equal importance to performance.
      </p>
      <p>
        As part of this commitment, {get_english_name()} previously completed the full Culture
        Assessment &amp; Audit across 11 domains of people and performance. Based on that
        audit, and with the support of Culture &amp; Wellness Facilitators and Own the Podium, the
        organization created an action plan focused on improving specific domain(s).
      </p>

      <p>
        This survey is a Culture Pulse Check on the domain(s) your program chose to prioritize.
        The goal is to understand progress in these areas and identify what is working well and
        where further improvement is needed.Because of your role, you have been invited to take part. 
      </p>
      <p>
        All responses are anonymous, and your openness will help guide meaningful
        improvements.
      </p>
    </div>
  );
};

const Intro = ({saveAnswer, title, intro,customElement,surveyEnabled,elementRef,language, organizationNameEn, organizationNameFr }) =>{

  const [agree1,setAgree1] = React.useState(false)
  const [agree2,setAgree2] = React.useState(false)
  const [agree3,setAgree3] = React.useState(false)
  const [agree4,setAgree4] = React.useState(false)
  const [agree5,setAgree5] = React.useState(false)
  const [agree6,setAgree6] = React.useState(false)
  const [agree7,setAgree7] = React.useState(true)
  const [agree8,setAgree8] = React.useState(false)


  const [expand1,setExpand1] = React.useState(false)
  const [expand2,setExpand2] = React.useState(false)
  const [expand3,setExpand3] = React.useState(false)
  const [expand4,setExpand4] = React.useState(false)
  const [expand5,setExpand5] = React.useState(false)
  const [expand6,setExpand6] = React.useState(false)
  const [expand7,setExpand7] = React.useState(false)

  function StartSurvey() {
    
    saveAnswer()

  }

  function expandAll(){
    setExpand1(!expand1)
    setExpand2(!expand2)
    setExpand3(!expand3)
    setExpand4(!expand4)
    setExpand5(!expand5)
    setExpand6(!expand6)
    setExpand7(!expand7)
  }

  React.useEffect(()=>{
    if(agree7){
      setAgree8(false)
    }
  },[agree7])

	return (
		<Container ref={elementRef}>
      
      <Content>
        <Image src={Logo}/>
  			<Title>{title}</Title>
        <Section>Introduction</Section>
  			<SubTitle expanded={true}><IntroText language={language} organizationNameEn={organizationNameEn} organizationNameFr={organizationNameFr} /></SubTitle>
        <SubTitle expanded={true}>{language==1?FR1:EN1}</SubTitle>

        <All onClick={()=>expandAll()}>{language==1?'Développer tout':'Expand All'}</All>

        <T2>{language==1?FR15:EN15} <Expand onClick={()=>setExpand6(!expand6)}><Icon name="chevron down"/></Expand></T2>
        <SubTitle expanded={expand6}>
        <p>{language === 1 ? FR16 : EN16}</p>
        <p>{language === 1 ? FR17 : EN17}</p>
        <p>{language === 1 ? FR18 : EN18}</p>
        <p>{language === 1 ? FR19 : EN19}</p>
        <p>{language === 1 ? FR20 : EN20}</p>

        </SubTitle>

        <Checkbox label={language==1?'Je comprends':'I understand'} color={'black'} onChange={()=>setAgree6(!agree6)} checked={agree6}/>

      


        

         <T2>{language==1?FR2:EN2}<Expand onClick={()=>setExpand1(!expand1)}><Icon name="chevron down"/></Expand></T2>
         <SubTitle expanded={expand1}>
         <p>{language==1?FR3:EN3}
         </p>
         </SubTitle>


           <Checkbox label={language==1?'Je comprends':'I understand'} color={'black'} onChange={()=>setAgree1(!agree1)} checked={agree1}/>

          <T2>{language==1?FR4:EN4} <Expand onClick={()=>setExpand2(!expand2)}><Icon name="chevron down"/></Expand></T2>
         <SubTitle expanded={expand2}>
         <p>{language==1?FR5:EN5}

         </p>
         </SubTitle>


           <Checkbox label={language==1?'Je reconnais':'I acknowledge'} color={'black'} onChange={()=>setAgree2(!agree2)} checked={agree2}/>


          <T2>{language==1?FR6:EN6} <Expand onClick={()=>setExpand3(!expand3)}><Icon name="chevron down"/></Expand></T2>
         <SubTitle expanded={expand3}>
         <p>{language==1?FR7:EN7}


         </p>
         </SubTitle>


           <Checkbox label={language==1?"J'accepte":'I consent'} color={'black'} onChange={()=>setAgree3(!agree3)} checked={agree3}/>


           {/* <T2>{language==1?FR23:EN23}</T2>
         <SubTitle expanded={true}>
         <p>{language==1?FR24:EN24}


         </p>
         </SubTitle> */}


           {/* <Checkbox label={language==1?"Oui, j'ai moins de 16 ans":'Yes, I am over the age of 16'} color={'black'} onChange={()=>setAgree7(true)} checked={agree7}/>
           <Checkbox label={language==1?"Non, j'ai plus de 16 ans":'No, I am under the age of 16'} color={'black'} onChange={()=>setAgree7(false)} checked={agree7===false}/> */}
{/* 
          <SubTitle expanded={agree7===false}>
         <p>
          {language==1?FR25:EN25}

         </p>
         <Checkbox label={language==1?"J'accepte":'I consent'} color={'black'} onChange={()=>setAgree8(!agree8)} checked={agree8}/>

         </SubTitle>  */}

           <T2>{language==1?FR8:EN8} <Expand onClick={()=>setExpand4(!expand4)}><Icon name="chevron down"/></Expand></T2>
            <SubTitle expanded={expand4}>
         <p style={{marginBottom:30}}>{language==1?FR9:EN9}
        
         </p>
         
         </SubTitle>


           <Checkbox label={language==1?"J'accepte":'I accept'} color={'black'} onChange={()=>setAgree4(!agree4)} checked={agree4}/>


           <T2>{language==1?FR10:EN10} <Expand onClick={()=>setExpand5(!expand5)}><Icon name="chevron down"/></Expand></T2>
         <SubTitle expanded={expand5}>
         <p>{language==1?FR11:EN11} 
         </p>
          <div style={{marginBottom:20}}>
          <Link to={'/otp/privacy'} target="_blank">{language==1?FR12:EN12}</Link>
         </div>

         <p>{language==1?FR13:EN13}</p>
         </SubTitle>

          <Checkbox label={language==1?"J'accepte":'I accept'} color={'black'} onChange={()=>setAgree5(!agree5)} checked={agree5}/>


          <T2>{language==1?FR21:EN21} <Expand onClick={()=>setExpand7(!expand7)}><Icon name="chevron down"/></Expand></T2>
          <SubTitle expanded={expand7}>
            {language==1?FR22:EN22} 

          </SubTitle>

          <SubTitle expanded={true}>
          <p>{language==1?FR14:EN14}</p></SubTitle>
  			<Next enabled={agree1 && agree2 && agree3 && agree4 && agree5 && agree6 && (agree7 || agree8)} onClick={StartSurvey} id="begin"> {language===1?'Commencer':'Begin'}</Next>
      </Content>
		</Container>

		)
}

export default Intro


const Title = styled.div`
	font-size: 26px;
  font-weight: bold;
  text-align:center;
  
  margin-bottom:15px;
  color:black;
   line-height:1.2;
   max-width:654px;

   @media only screen and (min-width:992px){
   font-size: 32px;
   margin-bottom:30px;
   line-height:1.3;
  }
`
const SubTitle = styled.div`
	font-size: 18px;
	line-height: 1.17;
  color: black;
  font-family: 'Barlow', sans-serif;
  margin-bottom:${props=>props.expanded?'20px':0};
  max-height:${props=>props.expanded?'1000px':0};
  overflow:hidden;
  transition:all 1s ease-in-out;


   @media only screen and (min-width:992px){
   margin-bottom:${props=>props.expanded?'10px':'10px'};
   font-size: 18px;
  }
`

const Next = styled.div`
	width: 170px;
  height: 47px;
   border-radius: 5px;
  background-color: #E5B63D;
  color: white;
   font-size: 16px;
  font-weight: bold;
  display:flex;
  align-items:center;
  justify-content:center;
  cursor:pointer;
  margin-top:30px;
  margin-bottom:50px;

  ${(props) => !props.enabled && `
    opacity: 0.5;
    cursor:auto;
    pointer-events: none;
  `}
`

const Container = styled.div`
  position:absolute;
  top:0%;
  width:100vw;
  padding:40px 20px;
  display:flex;
  flex-direction:column;
  align-items:center;

  @media only screen and (min-width:768px){
    left: 0%;
    top:0%;
  }


  @media(min-height:)
`

const T2 = styled.div`
  font-weight:bold;
  font-size:20px;
  margin-top:20px;
  margin-bottom:10px;
  align-items:center;
  justify-content:space-between;
  display:flex;
  width:100%;
  background-color:lightgrey;
  padding:10px;
`



const Image = styled.img`
  position:absolute;
  top:-140px;
  left:-80px;
  height:250px;

  @media(max-width:768px){
    height:150px;
    top:-80px;
    left:0px;
  }
`

const Content = styled.div`
  max-width:800px;
  position:relative;
  padding-top:50px;
  margin-top:60px;
`

const Section = styled.div`
  font-weight:bold;
    font-size: 18px;
  line-height: 1.17;
  margin-bottom:5px;
`

const Expand = styled.div`
  cursor:pointer;
`

const All = styled.div`
  width:100%;
  display:flex;
  justify-content:flex-end;
  margin-top:20px;
   font-size: 18px;
   text-decoration:underline;
   cursor:pointer;
`